const quantity = (num: number, singular: string, plural: string) => {
  return num == 1 ? singular : plural;
};

const ORDINAL_WORDS = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth"];
const ORDINAL_SUFFIXES: Record<number, string> = { 1: "st", 2: "nd", 3: "rd" };

const ordinal = (num: number): string => {
  if (num >= 1 && num <= ORDINAL_WORDS.length) return ORDINAL_WORDS[num - 1];

  const lastTwoDigits = num % 100;
  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${num}th`;

  return `${num}${ORDINAL_SUFFIXES[num % 10] ?? "th"}`;
};

export { quantity, ordinal };
